import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ItemEvento extends Component {
    render() {
        return (
            <li className="q_circle_outer" key={this.props.EventoNome}>
                <div className="q_circle_text_holder" style={{ border: '1px solid #e9e9e9',  listStylePosition: 'inside', paddingBottom: '8px', paddingTop: '8px', marginRight: '5px' }}>
                    <h3 className="q_circle_title">{this.props.EventoNome}</h3>
                    {this.props.AnoEtapa ? <h4 className="q_circle_title" style={{ height: '66px' }}>{this.props.AnoEtapa}</h4>:<div style={{ height: '66px' }}></div> }
                    <p className="q_circle_text" style={{
                        minHeight: '26px',
                        display: this.props.EventoVagas || this.props.EventoSalarioMaximo ? 'block' : 'hidden'
                    }}>
                        {this.props.EventoVagas && this.props.EventoVagas != 0 ? <span>{this.props.EventoVagas + ' vagas'}</span> : <span></span>}
                        {(this.props.EventoSalarioMaximo && this.props.EventoSalarioMaximo != 'R$0,00' && this.props.EventoSalarioMaximo != 'R$ 0,00' && this.props.EventoSalarioMaximo != 'R$ ') ? <span>{'Até ' + this.props.EventoSalarioMaximo}</span> : <span></span>}
                    </p>
                    <Link data-itemprop="url" className="icon_with_title_link" to={this.props.EventoURL}>MAIS INFORMAÇÕES</Link>
                    {/* <a data-itemprop="url" className="icon_with_title_link" href={this.props.EventoURL} target="_self">MAIS INFORMAÇÕES</a> */}
                </div>
            </li>
        );
    }
}

export default ItemEvento;